import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { ShowMoreTilesData } from '../../../analytics/event-tracking/trackShowMoreTiles';
import { PropertyCarousel } from '../../../app-kit/components/PropertyCarousel/PropertyCarousel';
import { PropertyTileProps } from '../../../app-kit/components/PropertyTile/PropertyTile';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

interface StreetPagePropertyCollectionBrickProps {
  title: string;
  subtitle: string;
  properties: PropertyTileProps[];
  tracking?: { showMoreProperties: ShowMoreTilesData } | null;
  showPropTrackLogo: boolean;
}

export const StreetPagePropertyCollectionBrick: FunctionComponent<
  StreetPagePropertyCollectionBrickProps
> = ({ title, subtitle, properties, tracking, showPropTrackLogo }) => {
  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <PropertyCarousel
        properties={properties}
        tracking={tracking?.showMoreProperties}
        preloadCount={3}
      />
      {showPropTrackLogo && <StyledProptrackLogoBrickSource />}
    </ContentBrick>
  );
};
